import { __assign } from "tslib";
import React from 'react';
import { InvoiceInfoCheck } from './InvoiceInfoCheck';
import { checkInvoicePayerName, checkInvoicePayerNumber, getCurrentPayerInfo, getCurrentSellerInfo } from './utils/invoiceCheckUtil';
import { get } from 'lodash';
import { isElectronicAirAndTrain } from '../../plugins/bills/layers/import-bill/invoice/ImportInvoiceUtils';
import { invoiceInfoFuncMap, getPhotoInvoiceInfo } from './utils/InvoiceDetailUtil';
import { TwoToneLogoAi } from '@hose/eui-icons';
var isShowCheck = function (item, isSeller) {
    var entity = item.entity, formData = item.formData;
    var mark = formData[i18n.get("E_{__k0}_\u8FDB\u9500\u9879\u6807\u8BC6", { __k0: entity })];
    return isShow(isSeller, mark);
};
export var isShow = function (isSeller, mark) {
    if (mark === 'OUTPUT_INVOICE_RECEIPT') {
        return isSeller;
    }
    else {
        return !isSeller;
    }
};
var BuyerName = {
    name: 'buyerName',
    label: i18n.get('购买方名称'),
    type: 'string',
    key: 'E_system_发票主体_购买方名称',
    customRender: function (item, additionalInfo) {
        var currentPayer = getCurrentPayerInfo(item);
        if (!isShowCheck(item, false)) {
            return currentPayer.name;
        }
        var payerNameCheckMsg = checkInvoicePayerName(currentPayer, additionalInfo);
        return React.createElement(InvoiceInfoCheck, __assign({}, payerNameCheckMsg));
    }
};
var BuyerCode = {
    name: 'buyerCode',
    label: i18n.get('纳税人识别号'),
    type: 'string',
    key: 'E_system_发票主体_购买方纳税人识别号',
    customRender: function (item, additionalInfo) {
        var currentPayer = getCurrentPayerInfo(item);
        if (!isShowCheck(item, false)) {
            return currentPayer.payerNo;
        }
        var payerNameCheckMsg = checkInvoicePayerNumber(currentPayer, additionalInfo);
        return React.createElement(InvoiceInfoCheck, __assign({}, payerNameCheckMsg));
    }
};
var Number = { name: 'number', label: i18n.get('发票号码'), type: 'number', key: 'E_system_发票主体_发票号码' };
var SecondaryInvoiceEntity = {
    ELECTRONIC_TRAIN_INVOICE: [
        BuyerName,
        BuyerCode,
        Number,
        { name: 'name', label: i18n.get('乘车人姓名'), type: 'string', key: 'E_system_发票主体_乘车人姓名' },
        { name: 'time', label: i18n.get('乘车时间'), type: 'time', key: 'E_system_发票主体_乘车时间' },
        { name: 'trainNumber', label: i18n.get('车次'), type: 'string', key: 'E_system_发票主体_车次' },
        { name: 'type', label: i18n.get('座位类型'), type: 'string', key: 'E_system_发票主体_座位类型' },
        { name: 'businessType', label: i18n.get('业务类型'), type: 'string', key: 'E_system_发票主体_业务类型' }
    ],
    ELECTRONIC_AIRCRAFT_INVOICE: [
        BuyerName,
        BuyerCode,
        Number,
        { name: 'name', label: i18n.get('乘机人姓名'), type: 'string', key: 'E_system_发票主体_乘机人姓名' },
        { name: 'time', label: i18n.get('乘机时间'), type: 'time', key: 'E_system_发票主体_乘机时间' },
        { name: 'seat', label: i18n.get('电子客票号码'), type: 'string', key: 'E_system_发票主体_电子客票号码' },
        { name: 'flightNumber', label: i18n.get('航班号'), type: 'string', key: 'E_system_发票主体_航班号' },
        { name: 'flight', label: i18n.get('航班'), type: 'string', key: 'E_system_发票主体_航班' },
        { name: 'seatType', label: i18n.get('航班舱型'), type: 'string', key: 'E_system_发票主体_航班舱型' },
    ]
};
export var invoiceFieldMap = {
    system_发票主体: [
        BuyerName,
        BuyerCode,
        {
            name: 'sellerName',
            label: i18n.get('销售方名称'),
            type: 'string',
            key: 'E_system_发票主体_销售方名称',
            customRender: function (item, additionalInfo) {
                var currentPayer = getCurrentSellerInfo(item);
                if (!isShowCheck(item, true)) {
                    return currentPayer.name;
                }
                var payerNameCheckMsg = checkInvoicePayerName(currentPayer, additionalInfo);
                return React.createElement(InvoiceInfoCheck, __assign({}, payerNameCheckMsg));
            }
        },
        {
            name: 'sellerCode',
            label: i18n.get('纳税人识别号'),
            type: 'string',
            key: 'E_system_发票主体_销售方纳税人识别号',
            customRender: function (item, additionalInfo) {
                var currentPayer = getCurrentSellerInfo(item);
                if (!isShowCheck(item, true)) {
                    return currentPayer.payerNo;
                }
                var payerNameCheckMsg = checkInvoicePayerNumber(currentPayer, additionalInfo);
                return React.createElement(InvoiceInfoCheck, __assign({}, payerNameCheckMsg));
            }
        },
        Number,
        { name: 'code', label: i18n.get('发票代码'), type: 'number', key: 'E_system_发票主体_发票代码' },
        { name: 'time', label: i18n.get('开票日期'), type: 'date', key: 'E_system_发票主体_发票日期' },
        { name: 'amountWithTax', label: i18n.get('价税合计'), type: 'money', key: 'E_system_发票主体_价税合计' },
        { name: 'tax', label: i18n.get('税额'), type: 'money', key: 'E_system_发票主体_税额' },
        {
            name: 'remark',
            label: i18n.get('备注'),
            type: 'string',
            key: 'E_system_发票主体_备注',
            defaultValue: i18n.get('无')
        }
    ],
    system_出租车票: [
        { name: 'code', label: i18n.get('发票代码'), type: 'number', key: 'E_system_出租车票_发票代码' },
        { name: 'number', label: i18n.get('发票号码'), type: 'number', key: 'E_system_出租车票_发票号码' },
        { name: 'number', label: i18n.get('车牌号码'), type: 'string', key: 'E_system_出租车票_车牌号码' },
        { name: 'startTime', label: i18n.get('上车时间'), type: 'time', key: 'E_system_出租车票_上车时间' },
        { name: 'endTime', label: i18n.get('下车时间'), type: 'time', key: 'E_system_出租车票_下车时间' },
        { name: 'distance', label: i18n.get('里程'), type: 'distance', key: 'E_system_出租车票_里程' },
        { name: 'moneyAmount', label: i18n.get('总金额'), type: 'money', key: 'E_system_出租车票_金额' },
        { name: 'location', label: i18n.get('所在地'), type: 'string', key: 'E_system_出租车票_发票所在地' }
    ],
    system_过路费发票: [
        { name: 'code', label: i18n.get('发票代码'), type: 'number', key: 'E_system_过路费发票_发票代码' },
        { name: 'number', label: i18n.get('发票号码'), type: 'number', key: 'E_system_过路费发票_发票号码' },
        { name: 'time', label: i18n.get('开票日期'), type: 'date', key: 'E_system_过路费发票_时间' },
        { name: 'startLocation', label: i18n.get('入口'), type: 'string', key: 'E_system_过路费发票_入口' },
        { name: 'endLocation', label: i18n.get('出口'), type: 'string', key: 'E_system_过路费发票_出口' },
        { name: 'moneyAmount', label: i18n.get('总金额'), type: 'money', key: 'E_system_过路费发票_金额' }
    ],
    system_定额发票: [
        { name: 'code', label: i18n.get('发票代码'), type: 'number', key: 'E_system_定额发票_发票代码' },
        { name: 'number', label: i18n.get('发票号码'), type: 'number', key: 'E_system_定额发票_号码' },
        { name: 'moneyAmount', label: i18n.get('总金额'), type: 'money', key: 'E_system_定额发票_金额' }
    ],
    system_火车票: [
        { name: 'number', label: i18n.get('车票号'), type: 'number', key: 'E_system_火车票_号码' },
        { name: 'name', label: i18n.get('乘车人'), type: 'string', key: 'E_system_火车票_乘车人姓名' },
        { name: 'trainNumber', label: i18n.get('车次'), type: 'string', key: 'E_system_火车票_车次' },
        { name: 'seat', label: i18n.get('席别'), type: 'string', key: 'E_system_火车票_座位类型' },
        { name: 'time', label: i18n.get('乘车时间'), type: 'time', key: 'E_system_火车票_乘车时间' },
        { name: 'startLocation', label: i18n.get('出发站'), type: 'string', key: 'E_system_火车票_上车车站' },
        { name: 'endLocation', label: i18n.get('到达站'), type: 'string', key: 'E_system_火车票_下车车站' },
        { name: 'moneyAmount', label: i18n.get('总金额'), type: 'money', key: 'E_system_火车票_金额' }
    ],
    system_航空运输电子客票行程单: [
        {
            name: 'name',
            label: i18n.get('乘机人'),
            type: 'string',
            key: 'E_system_航空运输电子客票行程单_乘机人姓名'
        },
        {
            name: 'flightNumber',
            label: i18n.get('航班号'),
            type: 'string',
            key: 'E_system_航空运输电子客票行程单_航班号'
        },
        { name: 'seat', label: i18n.get('航班舱型'), type: 'string', key: 'E_system_航空运输电子客票行程单_航班舱型' },
        {
            name: 'seat',
            label: i18n.get('电子客票号'),
            type: 'string',
            key: 'E_system_航空运输电子客票行程单_电子客票号码'
        },
        { name: 'time', label: i18n.get('乘机时间'), type: 'time', key: 'E_system_航空运输电子客票行程单_乘机时间' },
        {
            name: 'issueDate',
            label: i18n.get('填开日期'),
            type: 'date',
            key: 'E_system_航空运输电子客票行程单_填开日期'
        },
        {
            name: 'startLocation',
            label: i18n.get('出发站'),
            type: 'string',
            key: 'E_system_航空运输电子客票行程单_出发站'
        },
        {
            name: 'endLocation',
            label: i18n.get('到达站'),
            type: 'string',
            key: 'E_system_航空运输电子客票行程单_到达站'
        },
        {
            name: 'moneyAmount',
            label: i18n.get('总金额'),
            type: 'money',
            key: 'E_system_航空运输电子客票行程单_金额'
        },
        {
            name: 'ticketAmount',
            label: i18n.get('票价'),
            type: 'money',
            key: 'E_system_航空运输电子客票行程单_票价'
        },
        { name: 'tax', label: i18n.get('税费'), type: 'money', key: 'E_system_航空运输电子客票行程单_税费' },
        {
            name: 'fuel',
            label: i18n.get('燃油附加费'),
            type: 'money',
            key: 'E_system_航空运输电子客票行程单_燃油附加费'
        },
        {
            name: 'insurance',
            label: i18n.get('保险费'),
            type: 'money',
            key: 'E_system_航空运输电子客票行程单_保险费'
        },
        {
            name: 'fund',
            label: i18n.get('民航发展基金'),
            type: 'money',
            key: 'E_system_航空运输电子客票行程单_民航发展基金'
        }
    ],
    system_医疗发票: [
        { name: 'code', label: i18n.get('票据代码'), type: 'number', key: 'E_system_医疗发票_票据代码' },
        { name: 'number', label: i18n.get('票据号码'), type: 'number', key: 'E_system_医疗发票_票据号码' },
        { name: 'name', label: i18n.get('交款人'), type: 'string', key: 'E_system_医疗发票_交款人' },
        { name: 'type', label: i18n.get('发票种类'), type: 'string', key: 'E_system_医疗发票_发票种类' },
        { name: 'time', label: i18n.get('开票日期'), type: 'date', key: 'E_system_医疗发票_开票日期' },
        { name: 'moneyAmount', label: i18n.get('金额合计'), type: 'money', key: 'E_system_医疗发票_金额合计' }
    ],
    system_非税收入类票据: [
        { name: 'code', label: i18n.get('票据代码'), type: 'number', key: 'E_system_非税收入类票据_票据代码' },
        { name: 'number', label: i18n.get('票据号码'), type: 'number', key: 'E_system_非税收入类票据_票据号码' },
        { name: 'name', label: i18n.get('校验码'), type: 'string', key: 'E_system_非税收入类票据_校验码' },
        { name: 'time', label: i18n.get('开票日期'), type: 'date', key: 'E_system_非税收入类票据_开票日期' },
        { name: 'moneyAmount', label: i18n.get('金额合计'), type: 'money', key: 'E_system_非税收入类票据_金额合计' }
    ],
    system_客运汽车发票: [
        { name: 'code', label: i18n.get('发票代码'), type: 'number', key: 'E_system_客运汽车发票_发票代码' },
        { name: 'number', label: i18n.get('发票号码'), type: 'number', key: 'E_system_客运汽车发票_发票号码' },
        { name: 'name', label: i18n.get('乘车人'), type: 'string', key: 'E_system_客运汽车发票_姓名' },
        { name: 'time', label: i18n.get('乘车日期'), type: 'date', key: 'E_system_客运汽车发票_时间' },
        { name: 'moneyAmount', label: i18n.get('总金额'), type: 'money', key: 'E_system_客运汽车发票_金额' },
        { name: 'startLocation', label: i18n.get('出发地'), type: 'string', key: 'E_system_客运汽车发票_出发车站' },
        { name: 'endLocation', label: i18n.get('到达地'), type: 'string', key: 'E_system_客运汽车发票_达到车站' }
    ],
    system_机打发票: [
        { name: 'code', label: i18n.get('发票代码'), type: 'number', key: 'E_system_机打发票_发票代码' },
        { name: 'number', label: i18n.get('发票号码'), type: 'number', key: 'E_system_机打发票_发票号码' },
        { name: 'time', label: i18n.get('开票日期'), type: 'date', key: 'E_system_机打发票_时间' },
        { name: 'moneyAmount', label: i18n.get('总金额'), type: 'money', key: 'E_system_机打发票_金额' },
        { name: 'sellerName', label: i18n.get('销售方名称'), type: 'string', key: 'E_system_机打发票_销售方名称' }
    ],
    system_其他: [
        { name: 'time', label: i18n.get('开票日期'), type: 'date', key: 'E_system_其他_日期' },
        { name: 'moneyAmount', label: i18n.get('总金额'), type: 'money', key: 'E_system_其他_金额' }
    ],
    system_海外发票: [
        {
            name: 'summary',
            label: (React.createElement("div", { className: "invoice-ai-summary" },
                React.createElement(TwoToneLogoAi, null),
                i18n.get('AI智能总结'))),
            type: 'string',
            key: 'E_system_海外发票_AI智能总结',
            customRender: function (item) {
                var summary = get(item, 'formData.E_system_海外发票_AI智能总结', '');
                if (!(summary === null || summary === void 0 ? void 0 : summary.length)) {
                    return React.createElement("div", { className: "invoice-ai-summary-content" }, '-');
                }
                var summaryTexts = summary.split('\n');
                return (React.createElement("div", { className: "invoice-ai-summary-content" }, summaryTexts.map(function (text, index) {
                    return (React.createElement("div", { key: index, className: "invoice-ai-summary-content-row" }, text));
                })));
            }
        },
        { name: 'name', label: i18n.get('消费标题'), type: 'string', key: 'E_system_海外发票_title' },
        { name: 'time', label: i18n.get('日期'), type: 'date', key: 'E_system_海外发票_日期' },
        { name: 'rates', label: i18n.get('税率'), type: 'percent', key: 'E_system_海外发票_税率' },
        { name: 'Country', label: i18n.get('消费国家'), type: 'string', key: 'E_system_海外发票_消费国家' },
        { name: 'number', label: i18n.get('票据号码'), type: 'string', key: 'E_system_海外发票_票据号码' },
        { name: 'buyer', label: i18n.get('购买方'), type: 'string', key: 'E_system_海外发票_购买方名称' },
        { name: 'buyerTax', label: i18n.get('纳税人识别号'), type: 'string', key: 'E_system_海外发票_购买方纳税人识别号' },
        { name: 'seller', label: i18n.get('销售方名称'), type: 'string', key: 'E_system_海外发票_销售方名称' },
        { name: 'sellerTax', label: i18n.get('纳税人识别号'), type: 'string', key: 'E_system_海外发票_销售方纳税人识别号' }
    ],
    invoicePhoto: []
};
export function getInvoiceInfo(item, imageList, details) {
    if (!item.master) {
        return getPhotoInvoiceInfo(item, details);
    }
    var _a = item, master = _a.master, attachment = _a.attachment, entityType = _a.type, itemIds = _a.itemIds;
    var id = master && master.id;
    var entityId = master && master.entityId;
    var entity = entityId || entityType;
    var image = attachment ? attachment : imageList.find(function (image) { return (image === null || image === void 0 ? void 0 : image.id) === id; });
    var source = get(item, 'master.form.E_system_发票主体_来源');
    var entityInvoiceType = get(item, 'master.form.E_system_发票主体_发票类别');
    var otherInfo = invoiceInfoFuncMap[entity](item);
    var feeDetailAmount;
    var feeDetailName = '';
    var detailNo = 0;
    details &&
        details.length !== 0 &&
        details.forEach(function (detailItem, index) {
            var _a, _b, _c, _d, _e;
            if ((_b = (_a = detailItem === null || detailItem === void 0 ? void 0 : detailItem.feeTypeForm) === null || _a === void 0 ? void 0 : _a.invoiceForm) === null || _b === void 0 ? void 0 : _b.invoices) {
                (_e = (_d = (_c = detailItem.feeTypeForm) === null || _c === void 0 ? void 0 : _c.invoiceForm) === null || _d === void 0 ? void 0 : _d.invoices) === null || _e === void 0 ? void 0 : _e.forEach(function (invoicesItem) {
                    var hasItemIds = ((invoicesItem === null || invoicesItem === void 0 ? void 0 : invoicesItem.itemIds) || []).some(function (item) { return itemIds === null || itemIds === void 0 ? void 0 : itemIds.includes(item); });
                    if ((itemIds === null || itemIds === void 0 ? void 0 : itemIds.length) && hasItemIds) {
                        feeDetailAmount = detailItem.feeTypeForm.amount;
                        feeDetailName = detailItem.feeTypeId.fullname;
                        detailNo = index;
                    }
                    else if (!(itemIds === null || itemIds === void 0 ? void 0 : itemIds.length) && invoicesItem.invoiceId === id) {
                        feeDetailAmount = detailItem.feeTypeForm.amount;
                        feeDetailName = detailItem.feeTypeId.fullname;
                        detailNo = index;
                    }
                });
            }
        });
    var Entity = invoiceFieldMap[entity];
    if (isElectronicAirAndTrain(master.form)) {
        Entity = SecondaryInvoiceEntity[entityInvoiceType];
    }
    return __assign({ id: id, imageSrc: image && image.thumbUrl ? image.url : '', source: source, hasPDF: source === 'UPLOAD', formData: master.form, entity: entity,
        image: image, fields: Entity, feeDetailAmount: feeDetailAmount,
        feeDetailName: feeDetailName,
        detailNo: detailNo }, otherInfo);
}
